import { render, staticRenderFns } from "./itemSystemAdd.vue?vue&type=template&id=6a63b1c9&scoped=true"
import script from "./itemSystemAdd.vue?vue&type=script&lang=js"
export * from "./itemSystemAdd.vue?vue&type=script&lang=js"
import style0 from "./itemSystemAdd.vue?vue&type=style&index=0&id=6a63b1c9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a63b1c9",
  null
  
)

export default component.exports